import { reduceObject } from '../helpers/reduce-object';

import type { TData, TReplacer, TSwitchData } from './models';

export const collectSwitchData = (replace: TReplacer, switchData: TSwitchData = {}): TData =>
    reduceObject<Record<string, TData>, string | number | boolean>(
        switchData,
        (acc, [switchKey, cases]) => {
            try {
                const caseValue = replace(switchKey);
                if (caseValue in cases) {
                    const data = cases[caseValue];

                    return { ...acc, ...data };
                }
            } catch (err) {
                console.error(err);
            }

            return acc;
        }
    );
